module.exports = __webpack_public_path__ + "img/04g-Shop_651.31835bf0.jpg";